import { useUnit } from 'effector-react';
import {
  $uploadFilesModal,
  $uploadFilesStatus,
  changeUploadFilesModalEv,
  uploadFilesEv,
} from '../../models/bizPollsModel/index.js';
import { useEffect, useState } from 'react';
import Modal from 'antd/es/modal';
import Upload from 'antd/es/upload';
import { InboxOutlined } from '@ant-design/icons';

export default function UploadBizPollsFileModal() {
  const modal = useUnit($uploadFilesModal);
  const status = useUnit($uploadFilesStatus);
  const changeModal = useUnit(changeUploadFilesModalEv);
  const upload = useUnit(uploadFilesEv);
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (status === true) {
      setFile(null);
    }
  }, [status]);

  return (
    <Modal
      open={modal.open}
      destroyOnClose
      onCancel={() => {
        setFile(null);
        changeModal({ open: false, type: null });
      }}
      okText={'Загрузить'}
      okButtonProps={{ onClick: () => upload(file), disabled: !file }}
      cancelText={'Закрыть'}
      title={`Загрузить ${
        modal.type === 'bin'
          ? 'БИН постоянных респондентов'
          : 'ОКЭД (5 знаков) для отраслевых советов'
      }`}
    >
      <Upload.Dragger
        name="file"
        onChange={(e) => setFile(e.fileList[0].originFileObj)}
        multiple={false}
        onRemove={() => setFile(null)}
        beforeUpload={(file) => {
          setFile(file);
          return false;
        }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Нажмите чтобы выбрать файл или перетащите его в эту область
        </p>
      </Upload.Dragger>
      {status === true && (
        <p style={{ fontWeight: 700, fontSize: 18 }}>Файл успешно загружен</p>
      )}
      {typeof status === 'string' && (
        <p style={{ color: 'red', fontWeight: 700, fontSize: 18 }}>
          Произошла ошибка: {status}
        </p>
      )}
    </Modal>
  );
}
